import React from 'react';
import { store, persistor } from 'src/store';
import { Provider } from 'react-redux';
import Loading from 'components/chunk-loading';
import { PersistGate } from 'redux-persist/integration/react';
import Router from './router';
import utils from 'tools/utils';
utils.checkWebPSupport();
const App = () => <Provider store={store}>
  <PersistGate loading={null} persistor={persistor}>
    <React.Suspense fallback={<Loading />}>
      <Router />
    </React.Suspense>
  </PersistGate>
</Provider>;
export default App;
